import { Axios } from "utils";

export const getProgramHelps = async (programId) => {
  const res = await Axios.get(`/v2/portal/programs/${programId}/help`);
  return res.data;
};
